export default __webpack_public_path__ + "static/media/best-seller.436ba16e.png";